enum ErrorCode {
    ARGUMENT_ILLEGAL = "300",
    USER_NOT_LOGIN = "321"
}

export default ErrorCode
